import { atom } from "jotai"

import type { SbNavigationTextColor, SbNavigationTheme } from "~/lib/storyblok/types"

export const panelIndexAtom = atom<number | null>(null)
export const NavigationMobileVisibility = atom(false)
export const NavigationTheme = atom<SbNavigationTheme>("white")
export const NavigationTextColor = atom<SbNavigationTextColor>("ui-900")
